/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedSkeleton.defs.js'
export * as $defs from './getFeedSkeleton.defs.js'
